<template>
  <el-card  v-if="selectedReservation!=null" v-loading="loading" class="box grow scrollable only-y" :style="height">
    <!-- Controls -->
    <div style="position:relative;float:right;z-index:1000">
      <el-button-group class="animated fadeInRight">
       <el-button type="primary" icon="el-icon-edit" :disabled="!isEditable" size="mini" @click="$emit('edit')"></el-button>
       <!-- <el-button type="primary" icon="el-icon-check" size="mini" ></el-button> -->
       <el-button type="primary" icon="el-icon-s-release" :disabled="!isEditable" size="mini" @click="deleteReservation"></el-button>
     </el-button-group>
    </div>
    <!-- end controls -->
    <el-row style="margin-bottom:10px;">
      <el-page-header @back="$emit('close');" style="float:left;">
        <div slot="title">
          <span class="hidden-sm-and-down"></span>
        </div>
        <div slot="content">
        <span class="fs-20">{{$t('reservation.reservationNumber2')}}{{selectedReservation.id}}</span>
        </div>
      </el-page-header>
    </el-row>
    <el-card class="secondary-text" v-if="!isQuantityValid(null)">
      <i  class="mdi mdi-alert">&nbsp;</i>
      <span class="fs-14 secondary-text">{{$t('reservation.warningQtyAvailable')}}</span>
    </el-card>
    <el-tabs v-model="tab">
    <el-tab-pane :label="$t('reservation.overview')" name="overview">
      <ReservationInfos :reservation="selectedReservation"></ReservationInfos>
      <el-divider></el-divider>
      <el-row :gutter="20">
        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="6">
          <span class="fs-14 secondary-text">{{ $t('reservation.productField') }} </span>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <div class="fs-14 secondary-text">
            <i class="mdi mdi-barcode-scan" v-if="selectedReservation.product.type==1" style="margin-right:5px;color: grey;"></i>
            <span>
              <el-link v-if="selectedReservation.intent === false" @click="openProductInfo">{{selectedReservation.product.name}}</el-link>
              <span v-else>{{selectedReservation.product.name}}</span>
              <span v-if="selectedReservation.product.provider!=null">, <el-link @click="openProvider(selectedReservation.product.provider.id)">{{customerName(selectedReservation.product.provider)}}</el-link></span></span>
            <span class="fs-14 secondary-text" v-if="inventoryName"><br>{{inventoryName}}</span><br>
            <span class="fs-14 secondary-text">{{selectedReservation.product.sku}}</span><br>
            <UnitFormatVolumeLabel :unit="selectedReservation.product.unit" :uvc="selectedReservation.product.uvc" :format="selectedReservation.product.format" :volume="selectedReservation.product.volume"></UnitFormatVolumeLabel>
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="margin-top:10px;">
        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="6">
          <span class="fs-14 secondary-text">{{$t('reservation.qtyReservedField')}} </span>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <span class="fs-14 secondary-text">{{selectedReservation.qty}} </span>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="margin-top:10px;">
        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="6">
          <span class="fs-14 secondary-text">{{$t('reservation.qtyUsedField')}} </span>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <span class="fs-14 secondary-text">{{selectedReservation.quantity.qty_used}} </span>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="margin-top:10px;">
        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="6">
          <span class="fs-14 secondary-text">{{$t('reservation.qtyAvailableField')}} </span>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <span class="fs-14 secondary-text" v-if="selectedReservation.delayed || selectedReservation.intent">{{selectedReservation.qty - selectedReservation.quantity.qty_used}} {{$t('reservation.productInSupply')}}</span>
          <span class="fs-14 secondary-text" v-else>{{selectedReservation.quantity.qty_available}} </span>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="margin-top:10px;" v-if="selectedReservation.comment!=null">
        <el-col :xs="8" :sm="8" :md="8" :lg="8" :xl="6">
          <span class="fs-14 secondary-text">{{$t('reservations.Commentaries')}}</span>
        </el-col>
        <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <span class="fs-14 secondary-text">{{selectedReservation.comment}} </span>
        </el-col>
      </el-row>

    </el-tab-pane>
    <el-tab-pane :label="salesName" name="salesOrders">
      <el-table
      :data="selectedReservation.sales"
      :empty-text="$t('sales_orders.no_sales_orders')"
      style="width: 100%">
      <el-table-column
        prop="so_number"
        :label="$t('sales_orders.soNumber')"
        width="180">
        <template slot-scope="scope">
          <el-link @click="openSalesOrder(scope.row.id)">{{scope.row.so_number}}</el-link>
        </template>
      </el-table-column>
      <el-table-column
        prop="qty_ordered"
       :label="$t('sales_orders.quantity')"
        width="100">
      </el-table-column>
      <el-table-column
        :label="$t('sales_orders.status')">
        <template slot-scope="scope">
          <SalesOrderStatusTag :status="scope.row.status" />
        </template>
      </el-table-column>
    </el-table>
    </el-tab-pane>
  </el-tabs>
    <ProductDetailDrawer :puid="selectedReservation.puid"  direction="ltr" :visible="productDetailDrawerVisible" @close="closeProductDetailDrawer"></ProductDetailDrawer>
  </el-card>
</template>
<script>
import moment from 'moment-timezone'
import { mapActions, mapState, mapGetters } from 'vuex';
import ProductDetailDrawer from '@/views/pages/inventory/components/product-detail-drawer'
import PortausLink from '@/components/portaus-link'
import UnitFormatVolumeLabel from '@/components/product/unitFormatVolumeLabel'
import ReservationInfos from '@/components/reservation/reservation-infos'
import SalesOrderStatusTag from '@/views/pages/salesOrder/components/sales-order-status-tag'
export default {
  name : 'Reservation-view',
  props : {

  },
  data() {
    return {
      window : {
        width:0,
        height : 0,
      },
      productDetailDrawerVisible : false,
    };
  },components : {
    ProductDetailDrawer,
    PortausLink,
    UnitFormatVolumeLabel,
    ReservationInfos,
    SalesOrderStatusTag
    },
    methods : {
      closeProductDetailDrawer(){
        this.productDetailDrawerVisible = false;
      },
      openProductInfo(){
        this.productDetailDrawerVisible = true;
      },
      deleteReservation(){
        let message = "Le restant des produits (" + this.selectedReservation.quantity.qty_available + ") seront remis en disponibilité. Continuer?";
        if(this.selectedReservation.sales==null || this.selectedReservation.sales.length==0){
          message = "Ceci supprimera définitivement la réservation du système. Les produits (" + this.selectedReservation.quantity.qty_available + ") seront remis en disponibilité. Continuer?";
        }
        this.$confirm(message, 'Attention', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Annuler',
            type: 'warning'
          }).then(()=>{
            this.deleteSelectedReservation()
              .then(()=>{
                this.$emit('close');
              })
          }).catch(()=>{})

      },
      editReservation(){
          this.$emit('edit');
      },
      handleResize() {
        this.window.width = window.innerWidth;
        this.window.height = window.innerHeight;
      },
      _moment(datetime, format='LL'){
        return moment(datetime).format(format);

  		},
      openProvider(customerId){
        var index='/customers/'+customerId;
        this.$router.push(index);
      },
      openSalesOrder(salesOrderId){
        var index='/sales-orders/'+salesOrderId;
        this.$router.push(index);
      },
      ...mapActions('reservations',['deleteSelectedReservation','setActiveTab']),
    },
    computed : {
      inventoryName () {
        return _.get(this.selectedReservation, 'inventory.name');
      },
      isEditable () {

        let editable = !this.selectedReservation.completed;

        if (this.isRepCanModify || this.isCurrentUserAdmin) {
          return editable;
        } else {

          // Contrainte sur le créateur ou le REP
          const ids = [];
          if (_.get(this.selectedReservation, 'fk_sales_rep_id') != null) {
            ids.push(_.get(this.selectedReservation, 'fk_sales_rep_id') )
          }
          ids.push(_.get(this.selectedReservation, 'createdBy.id') )

          const rep = _.find(ids, id => id === this.getCurrentUserId);
          if (rep == null) {
            editable = false
          }

          return editable;
        }
        
      },
      followUpContactNotEmpty () {
        return this.selectedReservation != null &&
               this.selectedReservation.follow_up_contacts!=null &&
               this.selectedReservation.follow_up_contacts.length > 0;
      },
      contacts () {
        let contacts = null;
        _.forEach(this.selectedReservation.follow_up_contacts, (c, i) => {
          if (i==0) contacts = '';
          if (i==1) contacts += ', ';
          contacts += c.first_name + ' ' + c.last_name;
        })
        return contacts;
      },
      salesName(){
        let name = this.$i18n.t('reservation.sales')
        if(this.selectedReservation!=null && this.selectedReservation.sales!=null){
          name+= " ("+this.selectedReservation.sales.length+")";
        }
        return name;
      },
      height(){
        return "height :"+(this.window.height-200) + "px"
      },
      tab : {
        set(activeTab){this.setActiveTab(activeTab);},
        get(){return this.activeTab;}
      },
      ...mapState('reservations', [ 'selectedReservation','loading', 'selectedIndex','activeTab']),
      ...mapGetters('reservations',['isNegative','isPositive','isIntermediary','selectedReservationlimitDate', 'customerName','isQuantityValid']),
      ...mapGetters(['isRepCanModify', 'getCurrentUserId', 'isCurrentUserAdmin']),
      ...mapGetters('salesOrders', ['selectedSalesOrderTagType'])
    },
    created(){
      window.addEventListener('resize', this.handleResize)
      this.handleResize();

    },
    destroyed() {
      window.removeEventListener('resize', this.handleResize)
    }
  }
</script>
<style lang="scss" scoped>
@import '../../../../assets/scss/_variables';

.strike{
  text-decoration: line-through;
}

.addedItem{
  color : #5f8fdf;
}
.modifiedItem{
  color : #ec205f;
}

.el-alert{
  margin-bottom:10px;
}

.page-salesOrder{


	.salesOrder {
		background: white;
		width: 100%;
		max-width: 794px;
		min-height: 800px;
		margin: 0 auto;
		padding: 2em;
		box-sizing: border-box;
		box-shadow: 0px 8px 8px -8px rgba(0, 0, 0, 0.3);

		hr {
			border: 1px solid rgba(0, 0, 0, 0.05);
		}

		.salesOrder-top {
			overflow: hidden;
			margin-bottom: 30px;

			.logo {
				 float: left;
				height: 60px;
				width: 60px;
				box-sizing: border-box;
				overflow: hidden;
				text-align: center;

				img {
					height: 80%;
					margin-top: 10%;
				}
			}
			.info {
				display: block;
				float:left;
				margin-left: 20px;
				margin-top: 5px;

				& > * {
					margin: 0;
				}
			}
			.title {
				float: right;

				& > * {
					margin: 0;
				}

				p {
					text-align: right;
				}
			}
		}

		.salesOrder-middle {
			overflow: hidden;
			margin-top: 30px;
			margin-bottom: 30px;

			.clientlogo {
				float: left;
				height: 60px;
				width: 60px;
				box-sizing: border-box;
				border-radius: 50%;
				overflow: hidden;
				background: grey;

				img {
					width: 100%;
				}
			}

			.info {
				display: block;
				float:left;
				margin-left: 20px;
				margin-top: 5px;

				& > * {
					margin: 0;
				}
			}

			.deliveryDate{
				display: block;
				float:right;
				margin-top:20px;

				& > * {
					margin: 0;
				}
				.infoDelivery {
					font-weight:bold;

				}


			}

			.notes {
				margin-left: 52%;

				& > * {
					margin: 0;
				}
			}
		}

		.salesOrder-bottom {

			table {
				width: 100%;
				border-collapse: collapse;

				th {
					// text-align: right;
					// padding: 20px;
					padding-bottom: 5px;
					opacity: .7;

					&:first-child {
						text-align: left;
						padding-left: 0px;
						width: 100%;
					}
					&:last-child {
						padding-right: 0px;
					}
				}

				td {
					text-align: right;
					padding: 20px;
					// padding-bottom: 5px;
					border-bottom: 1px solid #EEE;
					font-size:13px;
          vertical-align:top;


					&:first-child {
						text-align: left;
						padding-left: 0px;
						width: 100%;
					}
					&:last-child {
						padding-right: 0px;
					}
				}

				tfoot td {
					border: none;
          padding:0px;
					padding-top: 5px;
          text-align:right;
          &:first-child {
						text-align: right;
						padding-left: 0px;
						width: 100%;
					}
					&:last-child {
						padding-right: 0px;
					}
				}
			}

		}

		h1 { font-size: 1.5em; color: #222; }
		h2 { font-size: .9em; }
		h3 { font-size: 1.2em; font-weight: 300; line-height: 2em; }
		p  { font-size: .7em; color: #666; line-height: 1.2em; }
	}

}


@media screen and (max-width: 900px) {
	.page-salesOrder {
		.salesOrder {
			.salesOrder-middle {
				.notes {
					display: block;
					width: 100%;
					clear: both;
					padding: 10px 0;
					margin: 0;

				}
				.info {
					display: block;
					width: 100%;
					clear: both;
					padding: 10px 0;
					margin: 0;


				}
			}
			.salesOrder-bottom {
				table {
					th {
						padding: 5px;
					}

					td {
						padding: 5px;
					}
				}
			}
		}
	}
}

@media print{
	.layout-container .container .footer ,
	.layout-container .container .header ,
	.layout-container .container .horizontal-nav ,
	.layout-container .footer ,
	.layout-container .layout-picker ,
	.layout-container .vertical-nav ,
	.layout-container .header {
		display:none;
	}

	.page-salesOrder {

		.salesOrder {
			box-shadow: none;
			max-width: 100%;
			padding: 0;
		}
	}
}
</style>
